export enum RemoteTransferType {    
    NotAValidRecipient = 0,
    RemoteDirectedDonor = 1,
    RemotePairedDonor = 2,
    GoodSamaritanDonor = 3,
    AdpVoucherDonor = 4,
    LocalDonor = 5
}